/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Account_Notifications_No_ExpiryInputs */

const he_account_notifications_no_expiry = /** @type {(inputs: Account_Notifications_No_ExpiryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ללא תפוגה`)
};

const en_account_notifications_no_expiry = /** @type {(inputs: Account_Notifications_No_ExpiryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No expiry`)
};

/**
* | output |
* | --- |
* | "No expiry" |
*
* @param {Account_Notifications_No_ExpiryInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const account_notifications_no_expiry = /** @type {((inputs?: Account_Notifications_No_ExpiryInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Account_Notifications_No_ExpiryInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_account_notifications_no_expiry(inputs)
	return en_account_notifications_no_expiry(inputs)
});